export default __webpack_public_path__ + "static/media/CI.72937237.svg";